import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AccountsRoutingModule_routes } from './account/account-routing-paths';
import { MainRoutingModule_routes } from './main/main-routing-paths';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/main/home',
    pathMatch: 'full'
  },
  {
    path: 'account',
    children: AccountsRoutingModule_routes
  },
  // {
  //   path: 'account/login',
  //   component: LoginPage
  // },
  // {
  //   path: 'account/register',
  //   component: RegisterPage
  // },
  {
    path: 'main', children: MainRoutingModule_routes
  }



];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),

  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
